import { render, staticRenderFns } from "./CRUDKits.vue?vue&type=template&id=473eae59&"
import script from "./CRUDKits.vue?vue&type=script&lang=js&"
export * from "./CRUDKits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports